import React, { useState } from 'react';

export const sidePanelViews = {
	MEAL_IDEAS: 'MEAL_IDEAS',
	GROCERY_LIST: 'GROCERY_LIST',
};

const options = [
	{ view: sidePanelViews.MEAL_IDEAS, label: 'Meal ideas', icon: 'restaurant_menu' },
	{ view: sidePanelViews.GROCERY_LIST, label: 'Grocery list', icon: 'shopping_cart' },
];

/**
 * The column beside the calendar. It shows the meal ideas until switched to the grocery list, since
 * planning the month is mostly choosing what to eat.
 *
 * Below the large breakpoint the column stacks under the calendar, far enough down that nobody
 * scrolls to it, so it is hidden there; the page's Meal Ideas and Groceries tabs cover it instead.
 */
export default function CalendarSidePanel({ mealIdeas, groceryList }) {
	const [view, setView] = useState(sidePanelViews.MEAL_IDEAS);

	return (
		<div className='calendar_side_panel hide-on-med-and-down'>
			<div className='calendar_side_panel__toggle'>
				{options.map((option) => (
					<button
						key={option.view}
						type='button'
						className={`btn-flat calendar_side_panel__option${view === option.view ? ' is-active' : ''}`}
						aria-pressed={view === option.view}
						onClick={() => setView(option.view)}
					>
						<i className='material-icons'>{option.icon}</i>
						{option.label}
					</button>
				))}
			</div>
			{view === sidePanelViews.MEAL_IDEAS ? mealIdeas : groceryList}
		</div>
	);
}
